<app-loading-spinner *ngIf="isLoading" [mode]="'thinking'"></app-loading-spinner>
<div class="modal-header">
  <h4 class="modal-title pull-left">Generate Library Codes</h4>
  <button
    type="button"
    class="btn-close close pull-right"
    aria-label="Close"
    (click)="bsModalRef.hide()"
  >
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form
    name="entryForm"
    #entryForm="ngForm"
    class="standard-form mt-2"
    (submit)="onSubmit()"
  >
    <div class="mb-3">
      <label class="form-label">Item ids</label>
     <input
        [ngModel]
        #title="ngModel"
        class="form-control"
        type="text"
        name="itemIds"
        id="itemIdsInput"
        placeholder="seperate published ids with a comma"
      />
      
    </div>
    <div class="mb-3">
      <label class="form-label">Number of codes</label>
     <input
        [ngModel]
        #title="ngModel"
        class="form-control"
        type="number"
        name="number"
        id="numberInput"
        placeholder="Enter number of codes you want to generate"
      />
    </div>

    <div class="mb-3">
      <label class="form-label">Days of access</label>
     <input
        [ngModel]
        #title="ngModel"
        class="form-control"
        type="number"
        name="days"
        id="daysInput"
        placeholder="Enter number of days you the codes to give access"
      />
    </div>

    
  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-cancel rounded-pill" (click)="bsModalRef.hide()">
    Close
  </button>
  <button class="btn btn-dark rounded-pill" (click)="onSubmit()">
    Create Codes
  </button>
</div>
